










































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Filter, FilterJson } from "@/domainproject/filter";
import { $_COLORS, Color } from "@/domainproject/colors";
import { $_FILTERS, deserializeFilter } from "@/domainproject/filters/all";
import PowerSlider from "@/components/PowerSlider.vue";
import ScaleSlider from "@/components/ScaleSlider.vue";
import WordToggle from "@/components/WordToggle.vue";

@Component({
  components: { PowerSlider, ScaleSlider, WordToggle }
})
export default class Sidebar extends Vue {
  @Prop() filters!: Filter[];

  selectedFilter = $_FILTERS.slugs[0];

  get $_colors() {
    return $_COLORS;
  }

  get $_filters() {
    return $_FILTERS;
  }

  get nextColor(): Color {
    return this.$_colors.items[this.filters.length % this.$_colors.length];
  }

  addFilter() {
    this.$emit("addFilter", {
      filter: this.selectedFilter,
      color: this.nextColor
    });
  }

  changeColor(filter: Filter, paramName: string) {
    const filters = this.filters.slice();
    filter.$_color = this.$_colors.get(paramName);
    this.$emit("input", filters);
  }

  setPower(filter: Filter, power: number) {
    const filters = this.filters.slice();
    filter.$_power = power;
    this.$emit("input", filters);
  }

  setScale(filter: Filter, scale: number) {
    const filters = this.filters.slice();
    filter.$_scale = scale;
    this.$emit("input", filters);
  }

  setToggle(filter: Filter, wordToggles: [boolean, boolean, boolean]) {
    const filters = this.filters.slice();
    [filter.$_firstWord, filter.$_middleWords, filter.$_lastWord] = wordToggles;
    this.$emit("input", filters);
  }

  toggleInv(filter: Filter) {
    const filters = this.filters.slice();
    filter.$_inv = !filter.$_inv;
    this.$emit("input", filters);
  }

  moveUp(i: number) {
    if (i > 0) {
      const filters = this.filters.slice();
      [filters[i - 1], filters[i]] = [filters[i], filters[i - 1]];
      this.$emit("input", filters);
    }
  }

  moveDown(i: number) {
    if (i < this.filters.length - 1) {
      const filters = this.filters.slice();
      [filters[i + 1], filters[i]] = [filters[i], filters[i + 1]];
      this.$emit("input", filters);
    }
  }

  close(uniqueId: number) {
    const filters = this.filters.filter(x => x.$_uniqueId != uniqueId);
    this.$emit("input", filters);
  }
}
